<template>
  <v-card class="pa-4" outlined elevation="8">
    <v-list-item class="px-6" height="88">
      <!-- <template v-slot:prepend>
        <v-avatar color="surface-light" size="32">🎯</v-avatar>
      </template> -->

      <template v-slot:title>
        <span class="text-h5">
          Ventes en points {{ selectedYear }} (prix tarif)
        </span>
      </template>

      <template v-slot:append>
        <v-btn
          class="text-white"
          color="#ffb500"
          :icon="
            type == 'table'
              ? mdiFileTableBoxMultipleOutline
              : mdiChartBoxMultipleOutline
          "
          slim
          @click="changeView"
        ></v-btn>
      </template>
    </v-list-item>
    <v-card-text v-if="type == 'chart'">
      <v-row justify="center" align="center" class="mb-4">
        <v-col cols="12" md="12" sm="12">
          <div id="chart">
            <apexchart
              type="bar"
              height="650"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </v-col>
      </v-row>
      <!-- <v-row justify="center" align="center" class="mb-4">
        <v-col cols="6" md="12" sm="12">
          <div id="chart">
            <apexchart
              type="bar"
              height="350"
              :options="chartOptions('points')"
              :series="seriesPoints"
            ></apexchart>
          </div>
        </v-col>
        <v-col cols="6" md="12" sm="12">
          <div id="chart">
            <apexchart
              type="bar"
              height="350"
              :options="chartOptions('forecastedPoints')"
              :series="seriesForecastedPoints"
            ></apexchart>
          </div>
        </v-col>
      </v-row> -->
    </v-card-text>
    <v-card-text v-else>
      <v-row>
        <v-col cols="11">
          <v-text-field
            v-model="search"
            label="Rechercher"
            :prepend-inner-icon="mdiMagnify"
            variant="outlined"
            hide-details
            single-line
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-btn
            :icon="mdiFileDownloadOutline"
            rounded="lg"
            border
            @click="exportExcelCustomer"
          ></v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="customersStatistics"
        :search="search"
        :items-per-page="-1"
        hide-default-footer
      >
        <template v-slot:item.customers="{ item }">
          <span v-for="customer in item.customers" :key="customer.id">
            <v-chip
              class="ma-1 text-white"
              color="#ffb500"
              variant="elevated"
              size="small"
            >
              {{ customer.number }}
            </v-chip>
          </span>
        </template>

        <template v-slot:item.statsContract.totalPastYear="{ item }">
          {{ item.statsContract.totalPastYear.toLocaleString("fr-FR") + " €" }}
        </template>

        <template v-slot:item.statsContract.totalCurrentYear="{ item }">
          {{
            item.statsContract.totalCurrentYear.toLocaleString("fr-FR") + " €"
          }}
        </template>

        <template v-slot:item.customer.fK_Status="{ item }">
          {{ item.customer.fK_Status < 0 ? 0 : item.customer.fK_Status }}
        </template>

        <template v-slot:item.statsContract.statusPastYear="{ item }">
          {{
            item.statsContract.statusPastYear < 0
              ? 0
              : item.statsContract.statusPastYear
          }}
        </template>

        <template v-slot:item.statsContract.totalPoints="{ item }">
          {{
            // Math.round(item.statsContract.totalPoints).toLocaleString("fr-FR")
            Math.round(totalToShow(item.statsContract))
              .toFixed(0)
              .toLocaleString("fr-FR")
          }}
        </template>

        <template
          v-slot:item.statsContract.forecastedPointsCurrentYearEnd="{ item }"
        >
          {{
            item.statsContract.forecastedPointsCurrentYearEnd.toLocaleString(
              "fr-FR",
            )
          }}
        </template>

        <template
          v-slot:item.statsContract.forecastedImpactCurrentYear="{ item }"
        >
          {{
            item.statsContract.forecastedImpactCurrentYear.toLocaleString(
              "fr-FR",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 },
            ) + " €"
          }}
        </template>

        <template v-slot:tfoot>
          <tr class="bg-grey-lighten-4">
            <td class="font-weight-bold pl-4">Total :</td>
            <td class="text-center">-</td>
            <td class="text-center">-</td>
            <td class="text-center">-</td>
            <td class="text-center">
              {{ getTotalValueFormatted("statsContract.totalPastYear") }} €
            </td>
            <td class="text-center">
              {{ getTotalValueFormatted("statsContract.totalCurrentYear") }} €
            </td>
            <td class="text-center">
              {{ getTotalValueFormatted("statsContract.totalPoints") }}
            </td>
            <td class="text-center">
              {{
                getTotalValueFormatted(
                  "statsContract.forecastedPointsCurrentYearEnd",
                )
              }}
            </td>
          </tr>
        </template>

        <!-- <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </template> -->
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import {
  mdiChartBoxMultipleOutline,
  mdiFileTableBoxMultipleOutline,
  mdiMagnify,
  mdiFileDownloadOutline,
} from "@mdi/js";

export default {
  name: "ThridTabKpi",
  components: {},
  props: {
    selectedYear: {
      type: Number,
      required: true,
    },
    selectedMonth: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      mdiChartBoxMultipleOutline,
      mdiFileTableBoxMultipleOutline,
      mdiFileDownloadOutline,
      mdiMagnify,
      search: "",
      type: "table",
    };
  },
  computed: {
    ...mapState({
      customersStatistics: (state) => state.kpi.customersStatistics,
    }),
    series() {
      return [
        {
          name: `Chiffre d'affaires ${this.selectedYear}`,
          data: this.$store.state.kpi.customersStatistics.map(
            (item) => item.statsContract.totalCurrentYear,
          ),
        },
        {
          name: `Chiffre d'affaires ${this.selectedYear - 1}`,
          data: this.$store.state.kpi.customersStatistics.map(
            (item) => item.statsContract.totalPastYear,
          ),
        },
        {
          name: `Total des points ${this.selectedYear}`,
          data: this.$store.state.kpi.customersStatistics.map(
            (item) => item.statsContract.totalPoints,
          ),
        },
        {
          name: `Points prévisionnels fin ${this.selectedYear}`,
          data: this.$store.state.kpi.customersStatistics.map(
            (item) => item.statsContract.totalPastYear,
          ),
        },
      ];
    },
    /**
     * Retourne la liste des catégories pour l'axe X du graphique.
     * Chaque catégorie est composée du nom et du numéro du client.
     * @returns {Array<string>} Liste des catégories formatées
     */
    customers() {
      return this.customersStatistics.map(
        (item) => `${item.contractReference}`,
      );
    },
    pageCount() {
      return Math.ceil(this.customersStatistics.length / 10);
    },
    headers() {
      return [
        { title: "Contrat", key: "contractReference" },
        {
          title: `Clients`,
          key: "customers",
          align: "center",
        },
        {
          title: `Statut ${this.selectedYear - 1}`,
          key: "statsContract.statusPastYear",
          align: "center",
        },
        {
          title: `Statut ${this.selectedYear}`,
          key: "customers[0].statut",
          align: "center",
        },
        {
          title: `CA ${
            this.selectedYear - 1
          } (YTD) pris en compte dans le programme One`,
          key: "statsContract.totalPastYear",
          align: "center",
        },
        {
          title: `CA ${this.selectedYear} (YTD) pris en compte dans le programme One`,
          key: "statsContract.totalCurrentYear",
          align: "center",
        },
        {
          title: `Total des points ${this.selectedYear}`,
          value: "statsContract.totalPoints",
          align: "center",
        },
        {
          title: `Points prévisionnels fin ${this.selectedYear}`,
          value: "statsContract.forecastedPointsCurrentYearEnd",
          align: "center",
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "bar",
          events: {
            click: () => {
              // Gérer l'événement de clic ici
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          max: undefined,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
          categories: this.customers,
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "chartTitle",
          },
        },
      };
    },
  },
  methods: {
    totalToShow(item) {
      var consommable = item.consommablePoints;
      var capital = item.capitalPoints;
      var implant = item.implantPoints;
      var service = item.servicePoints;
      var total = consommable + capital + implant + service;
      total;
      Math.round(total).toFixed(0);
      return total;
    },
    exportExcelCustomer() {
      this.$store.commit("setOverlay", true);
      this.$store
        .dispatch("kpi/exportExcelCustomer", {
          year: this.selectedYear,
          month: this.selectedMonth,
        })
        .then((response) => {
          this.$store.commit("setOverlay", false);
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // Create a link element
          const link = document.createElement("a");
          // Set the download attribute with the desired file name
          link.download = "ClientsKPI.xlsx";

          // Create a URL for the Blob and set it as the link's href
          link.href = window.URL.createObjectURL(blob);

          // Append the link to the document
          document.body.appendChild(link);

          // Trigger a click on the link to start the download
          link.click();

          // Remove the link from the document
          document.body.removeChild(link);
        })
        .catch((error) => {
          if (error.status == 400) {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: "Action non autorisée.",
              color: "error",
            });
          } else {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.export-excel"),
              color: "error",
            });
          }
        });
    },
    changeView() {
      this.type = this.type === "table" ? "chart" : "table";
    },
    /**
     * Calcule la somme totale d'une propriété spécifique sur tous les éléments de customersStatistics
     * @param {string} property - La propriété à totaliser (peut être imbriquée comme 'statsContract.totalPoints')
     * @returns {number|string} - Le total calculé ou '-' pour les propriétés non applicables
     */
    getTotalValue(property) {
      // Gestion des propriétés non totalisables
      if (
        property === "contractReference" ||
        property === "customers" ||
        property === "customers[0].statut"
      ) {
        return "-";
      }

      // Gestion spéciale pour totalPoints : utiliser la méthode totalToShow
      if (property === "statsContract.totalPoints") {
        return this.customersStatistics.reduce((acc, item) => {
          return acc + this.totalToShow(item.statsContract);
        }, 0);
      }

      return this.customersStatistics.reduce((acc, item) => {
        // Gestion des propriétés imbriquées
        let value = item;
        const props = property.split(".");
        for (const prop of props) {
          value = value?.[prop];
        }
        return acc + (Number(value) || 0);
      }, 0);
    },
    /**
     * Retourne la valeur totale formatée pour l'affichage
     * @param {string} property - La propriété à totaliser
     * @returns {string} - Le total formaté en français
     */
    getTotalValueFormatted(property) {
      const total = this.getTotalValue(property);
      if (total === "-") return "-";
      return Math.round(total).toLocaleString("fr-FR");
    },
  },
};
</script>

<style scoped>
.bg-grey-lighten-4 {
  background-color: rgb(245, 245, 245);
}

.bg-grey-lighten-4 td {
  font-weight: 500;
}
</style>
